import { useMessage } from '@/common/inject/useMessage';
import axios from 'axios';
import { MessageSchemaStringType, useInternational } from '@/common/locale';

export const useVueQueryErrorHandler = () => {
  const { t } = useInternational();
  const { showErrorMsg } = useMessage();

  const getErrorText = ({
    error,
    validateStatus,
    errorMsg,
  }: {
    error: unknown;
    validateStatus?: ((status: number) => boolean) | null;
    errorMsg?:
      | MessageSchemaStringType
      | ((e: { status: number }) => MessageSchemaStringType | null | undefined);
  }): string => {
    if (axios.isAxiosError(error) && error.response?.status) {
      const { status } = error.response;
      const errorMsgSchema = typeof errorMsg === 'function' ? errorMsg({ status }) : errorMsg;

      if (validateStatus && !validateStatus(status)) {
        return t(errorMsgSchema ?? 'NOTI.PRODUCT.TEMP_SERVER_ERROR');
      } else if (status === 406 || status === 408) {
        /*
         * Axios Interceptor에서 406, 408 오류에 대한 처리를 해주기 때문에
         */
        return '';
      } else if (status === 409) {
        return t('NOTI.VALIDATION.DUPLICATE');
      } else if (status === 404) {
        return t('MESSAGE.NOT_FOUND_TARGET');
      } else {
        return t(errorMsgSchema ?? 'NOTI.PRODUCT.TEMP_SERVER_ERROR');
      }
    }
    return '';
  };

  const errorHandlerWithMessage = ({
    error,
    validateStatus,
    errorMsg,
  }: {
    error: unknown;
    validateStatus?: ((status: number) => boolean) | null;
    errorMsg?:
      | MessageSchemaStringType
      | ((e: { status: number }) => MessageSchemaStringType | null | undefined);
  }) => {
    const errorText = getErrorText({ error, validateStatus, errorMsg });

    if (errorText) {
      showErrorMsg({ msgStr: errorText });
      return;
    }
  };

  return {
    errorHandlerWithMessage,
    getErrorText,
  };
};
